import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagTM = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#496E2D",
  d: "M25 0c-1.866 0-3.685.206-5.434.594L18.479 25l1.087 24.405c1.75.388 3.568.594 5.434.594 13.807 0 25-11.192 25-25C50 11.194 38.807 0 25 0ZM6.522 8.161A24.908 24.908 0 0 0 0 25a24.91 24.91 0 0 0 6.522 16.838L7.609 25 6.522 8.16Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M36.563 18.857a7.61 7.61 0 0 0-3.117-9.014 7.608 7.608 0 1 1-5.02 13.99 7.61 7.61 0 0 0 8.137-4.976ZM29.742 8.903l-1.069 1.381-1.643-.59.983 1.444-1.069 1.38 1.677-.488.983 1.443.052-1.746 1.677-.489-1.644-.59.053-1.745Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "m32.626 13.403-1.069 1.38-1.643-.589.983 1.443-1.069 1.381 1.677-.489.983 1.443.053-1.745 1.676-.49-1.644-.589.053-1.745ZM24.653 10.542l-1.07 1.381-1.643-.59.983 1.444-1.068 1.38 1.676-.489.983 1.444.053-1.746 1.676-.489-1.643-.59.053-1.745ZM24.536 15.697l-1.069 1.38-1.643-.589.983 1.443-1.069 1.381 1.676-.489.983 1.443.053-1.745 1.677-.49-1.644-.589.053-1.745ZM29.442 17.456l-1.069 1.381-1.643-.59.983 1.444-1.07 1.38 1.677-.488.983 1.443.053-1.746 1.676-.489-1.643-.59.053-1.745Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M6.521 8.161v33.677a24.974 24.974 0 0 0 13.044 7.567V.595A24.973 24.973 0 0 0 6.52 8.16Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "m11.5 13.162-2.184-1.627v-2.3L11.5 7.608h3.088l2.184 1.627v2.3l-2.183 1.627H11.5Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FF9811",
  d: "M13.044 7.608H11.5L9.316 9.235v1.125h3.728V7.608ZM13.045 13.162h1.544l2.184-1.627v-1.173h-3.728v2.8Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "m11.5 42.391-2.184-1.627v-2.3l2.184-1.627h3.088l2.184 1.627v2.3l-2.183 1.627H11.5Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FF9811",
  d: "M13.044 36.837H11.5l-2.184 1.627v1.125h3.728v-2.752ZM13.045 42.391h1.544l2.184-1.627v-1.173h-3.728v2.8Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#496E2D",
  d: "M11.498 27.777 9.314 26.15v-2.3l2.184-1.627h3.088l2.184 1.627v2.3l-2.184 1.627h-3.088ZM16.847 31.355h-.951v-.95h-1.672l-1.181-1.183-1.182 1.182h-1.672v.951h-.95v1.902h.95v.952h1.672l1.182 1.181 1.181-1.181h1.672v-.952h.95v-1.902ZM16.847 16.741h-.951v-.95h-1.672l-1.181-1.183-1.182 1.182h-1.672v.951h-.95v1.902h.95v.951h1.672l1.182 1.182 1.181-1.181h1.672v-.952h.95v-1.902Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M11.957 23.912h2.174v2.174h-2.174v-2.174ZM13.044 18.779a1.087 1.087 0 1 0 0-2.174 1.087 1.087 0 0 0 0 2.174ZM13.044 33.394a1.087 1.087 0 1 0 0-2.174 1.087 1.087 0 0 0 0 2.174Z"
}));
FlagTM.displayName = 'FlagTM';
export default withFlagWrapper(FlagTM);
//# sourceMappingURL=index.js.map